var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8d816888fd2868f8dbcc277ae6fa11a84429cd3c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["circular-react@circular-exchange"]={id:"8d816888fd2868f8dbcc277ae6fa11a84429cd3c"};
      